import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    tomselect = null;
    originalOnChange = null;

    connect() {
        hidePreloader();

        this.originalOnChange = this.element.onchange;
        this.initializeTomSelect();
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy();
            this.tomselect = null;
        }
    }

    initializeTomSelect() {
        if (this.element.tomselect) {
            return;
        }

        const statusConfig = {
            '': {
                badgeColor: 'bg-primary',
                textColor: 'text-primary', // primary
            },
            'publish': {
                badgeColor: 'bg-success',
                textColor: 'text-success', // maingreen
            },
            'paused': {
                badgeColor: 'bg-warning',
                textColor: 'text-warning', // mainorange
            },
            'closed': {
                badgeColor: 'bg-danger',
                textColor: 'text-danger', // red
            },
        };

        const options = {
            render: {
                option: (data, escape) => {
                    const config = statusConfig[data.value] || statusConfig[''];

                    return `
                        <div class="jobs-listing d-flex align-items-center py-1">
                            <span class="badge ${config.badgeColor} d-block rounded-circle me-1"></span>
                            <span class="${config.textColor} ps-1">${escape(data.text)}</span>
                        </div>
                    `;
                },
                item: (data, escape) => {
                    const config = statusConfig[data.value] || statusConfig[''];

                    return `
                        <div class="jobs-listing d-flex align-items-center">
                            <span class="badge ${config.badgeColor} d-block rounded-circle me-1"></span>
                            <span class="${config.textColor} ps-1">${escape(data.text)}</span>
                        </div>
                    `;
                },
            },
            controlInput: null,
            dropdownParent: 'body',
            allowEmptyOption: true,
            hideSelected: true,
            onChange: (value) => {
                showPreloader();

                // Fire the native change event for Live Components to detect
                const event = new Event('change', { bubbles: true });
                this.element.dispatchEvent(event);

                // Call original onchange handler if it exists (for inline handlers)
                if (this.originalOnChange) {
                    this.originalOnChange.call(this.element, event);
                }
            },
        };

        this.tomselect = new TomSelect(this.element, options);

        // Add custom class to wrapper for styling
        if (this.tomselect.wrapper) {
            this.tomselect.wrapper.classList.add('job-offer-status-select');
            this.tomselect.dropdown.classList.add('job-offer-custom-select');
        }
    }
}
